import { render, staticRenderFns } from "./BuyManage.vue?vue&type=template&id=3ae6c01a&scoped=true&"
import script from "./BuyManage.vue?vue&type=script&lang=js&"
export * from "./BuyManage.vue?vue&type=script&lang=js&"
import style0 from "./BuyManage.vue?vue&type=style&index=0&id=3ae6c01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae6c01a",
  null
  
)

export default component.exports